import { render, staticRenderFns } from "./multipletextitem.vue?vue&type=template&id=22488812&"
import script from "./multipletextitem.vue?vue&type=script&lang=ts&"
export * from "./multipletextitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22488812')) {
      api.createRecord('22488812', component.options)
    } else {
      api.reload('22488812', component.options)
    }
    module.hot.accept("./multipletextitem.vue?vue&type=template&id=22488812&", function () {
      api.rerender('22488812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/multipletextitem.vue"
export default component.exports